import Header from "../../../components/header";
import Footer from "../../../components/footer";
import TeachersListingBanner from '../../components/01_banner/01_banner';

import { useEffect, useMemo, useRef, useState } from "react";
import style from "./01_teacherslisting.css"

import searchicon from "../../Images/search_icon.svg"
import tempicon from "../../Images/temp_icon.svg"

import icon1 from "../../Images/free_01.png"
import icon2 from "../../Images/education.png"
import icon3 from "../../Images/guitar-instrument.png"
import icon4 from "../../Images/verify.png"
import PricingStudents from "../../components/02_pricingstudents/02_pricingstudents";

export default function TeachersListing() {
  const [people, setPeople] = useState([]);
  const [loading, setLoading] = useState(true);
  const [navHovered, setNavHovered] = useState(false); 
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [sortOrder, setSortOrder] = useState("A-Z");
  const [currentPage, setCurrentPage] = useState(1);

  const resultsRef = useRef(null);

  const itemsPerPage = 4;

  // Fetch JSON
  useEffect(() => {
    fetch("https://sursaathi.in/teacherslisting/teacherslisting.json")
      .then((res) => res.json())
      .then((data) => {
        setPeople(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error loading teachers:", err);
        setLoading(false);
      });
  }, []);

  // Reset page whenever search/filter/sort changes
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, selectedLocations, sortOrder]);

  // Unique locations
  const locations = useMemo(() => {
    return [...new Set(people.map((person) => person.Instrument))].sort();
  }, [people]);

  // Search + Filter + Sort
  const filteredData = useMemo(() => {
    let data = [...people];

    // SEARCH
    if (searchTerm.trim()) {
      const search = searchTerm.toLowerCase();

      data = data.filter((person) => {
        return (
          person.Name?.toLowerCase().includes(search) ||
          person.Location?.toLowerCase().includes(search) ||
          person.Instrument?.toLowerCase().includes(search) ||
          person.Language?.toLowerCase().includes(search) ||
          person.Description?.toLowerCase().includes(search) ||
          person.Headline?.toLowerCase().includes(search)
        );
      });
    }

    // LOCATION FILTER
    if (selectedLocations.length > 0) {
      data = data.filter((person) =>
        selectedLocations.includes(person.Instrument)
      );
    }

    // SORT
    data.sort((a, b) =>
      sortOrder === "A-Z"
        ? a.Name.localeCompare(b.Name)
        : b.Name.localeCompare(a.Name)
    );

    return data;
  }, [people, searchTerm, selectedLocations, sortOrder]);

  // Pagination
  const totalPages = Math.max(
    1,
    Math.ceil(filteredData.length / itemsPerPage)
  );

  const currentItems = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Checkbox handler
  const handleLocationChange = (Instrument) => {
    setSelectedLocations((prev) =>
      prev.includes(Instrument)
        ? prev.filter((item) => item !== Instrument)
        : [...prev, Instrument]
    );
  };

  if (loading) {
    return (
      <div style={{ backgroundColor: "#FFFDF4" }}>
        <Header />
        <div style={{ padding: "50px", textAlign: "center" }}>
          Loading teachers...
        </div>
        <Footer />
      </div>
    );
  }

  const handleQuickSearch = (keyword) => {
    setSearchTerm(keyword);

    // Wait for React to update before scrolling
    setTimeout(() => {
      resultsRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();

    resultsRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  
  const sections = [ 

  ]; 
  
  const scrollToSection = (id) => { 
      document.getElementById(id)?.scrollIntoView({ 
          behavior: "smooth", 
          block: "start", 
      }); 
  };

  return (
    <div style={{ backgroundColor: "#FFFDF4", minHeight: "100vh" }}>
      <Header />
      <div className={`hind ${ navHovered ? "bgactive" : "" }`}></div>
      <section className="TeachersListingPage-Hero">
        <h1>Discover the Joy of Music. Learn Anytime, Anywhere, at Your Fingertips.</h1>
        <p>Finding and contacting teachers on SurSaathi is 100% free. Teachers set their own lesson fees, and payments are made directly to them. SurSaathi never charges students or takes a commission.</p>
        <form
          onSubmit={handleSearchSubmit}
          className="TeachersListingPage-Hero-Form"
        >
          <input
            type="text"
            placeholder="Search teachers, instruments, locations..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />

          <button type="submit">
            <img src={searchicon} alt="" />
          </button>
        </form>
        {/*
        <div className="TeachersListingPage-Hero-QuickLinks">
          <button onClick={() => handleQuickSearch("Violin")}>
            Violin
          </button>

          <button onClick={() => handleQuickSearch("Piano")}>
            Piano
          </button>

          <button onClick={() => handleQuickSearch("Guitar")}>
            Guitar
          </button>
        </div>
        */}
        <span>Trusted by: 10,000+ people in India</span>
      </section>
      <div className="TeachersListingPage-TrustSection">
        <div className="TeachersListingPage-TrustSection-Cards"> 
          <img src={icon1} alt="" />
          <p>100% Free to Search & Connect</p>
        </div>
        <div className="TeachersListingPage-TrustSection-Cards"> 
          <img src={icon2} alt="" />
          <p>Online & Offline Learning</p>
        </div>
        <div className="TeachersListingPage-TrustSection-Cards"> 
          <img src={icon3} alt="" />
          <p>Wide Range of Instruments & Vocals</p>
        </div>
        <div className="TeachersListingPage-TrustSection-Cards"> 
          <img src={icon4} alt="" />
          <p>Verified Music Teachers</p>
        </div>{/*<button >Done</button>*/}
      </div>
      <div className="TeachersListingPage-ListingSection">
        <div className={`TeachersListingPage-ListingSection-Filters ${ navHovered ? "filactive" : "" }`}>
          {/* SORT */}
          <span>SORT BY</span>
          <div className="TeachersListingPage-ListingSection-Filters-radio">
            <label>
              <input
                type="radio"
                name="sort"
                value="A-Z"
                checked={sortOrder === "A-Z"}
                onChange={(e) => setSortOrder(e.target.value)}
              />{""}
              Name A-Z
            </label>
            <label>
              <input
                type="radio"
                name="sort"
                value="Z-A"
                checked={sortOrder === "Z-A"}
                onChange={(e) => setSortOrder(e.target.value)}
              />{""}
              Name Z-A
            </label>
          </div>
          {/* FILTERS 
          <span>Instruments</span>

          <div className="TeachersListingPage-ListingSection-Filters-radio">
            {locations.map((Instrument) => (
              <label key={Instrument}>
                <input
                  type="checkbox"
                  checked={selectedLocations.includes(Instrument)}
                  onChange={() => handleLocationChange(Instrument)}
                />{""}
                {Instrument}
              </label>
            ))}
          </div>
          */}
          <button onClick={() => setNavHovered(false)}>Done</button>
        </div>
        <div className="TeachersListingPage-ListingSection-Lists">
          <button className="TeachersListingPage-ListingSection-Lists-Filter"
          onClick={() => setNavHovered(true)}
          >
              SORT | FILTERS
            </button>
          <div className="TeachersListingPage-ListingSection-Listing-Heading">
            {/* SEARCH */}
            <input
              type="text"
              placeholder="Search teachers..."
              value={searchTerm}
              className="TeachersListingPage-ListingSection-Listing-Heading-SearchBar"
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button type="submit">
              <img src={searchicon} alt="" />
            </button>
            <span className="TeachersListingPage-ListingSection-Listing-Heading-Results">
              SHOWING {currentPage} OF {totalPages} PAGES
            </span>
          </div>
          <div ref={resultsRef} className="TeachersListingPage-ListingSection-Listing-List">
            {/* RESULTS */}

            {currentItems.length === 0 ? (
              <p>No teachers found.</p>
            ) : (
              <>
                {currentItems.map((person) => (
                  <a key={person.UID} className="TeachersListingPage-ListingSection-Listing-List-Card" href={person.URL}>
                    <img src={person.PhotoURL} alt="" />
                    <div className="TeachersListingPage-ListingSection-Listing-List-Card-Info">
                      <h2>{person.Name}</h2>
                      <div className="TeachersListingPage-ListingSection-Listing-List-Card-Info-Keys">
                        <span>Instrument: {person.Instrument}</span>
                        <span>Location:{person.Location}</span>
                      </div>
                      <p>{person.Description}</p>
                    </div>                    
                  </a>
                ))}

                {/* PAGINATION */}

                <div className="TeachersListingPage-ListingSection-Listing-Pagination">
                  <button
                    onClick={() =>
                      setCurrentPage((page) => Math.max(page - 1, 1))
                    }
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>

                  <span>
                    Page {currentPage} of {totalPages}
                  </span>

                  <button
                    onClick={() =>
                      setCurrentPage((page) =>
                        Math.min(page + 1, totalPages)
                      )
                    }
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </div>
              </>
            )}
            </div>
        </div>
      </div>
      <PricingStudents />
      <TeachersListingBanner />
      <Footer />
    </div>
  );
}